export default __webpack_public_path__ + "static/media/cmt.80f98b99.jpg";